import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useRouter } from "next/router";

import Header from "../components/Header/Header";
import { Container } from "@mui/material";
import SearchResult from "../components/SearchResult/SearchResult";
import SimpleBackdrop from "../components/Backdrop/SimpleBackdrop";
import StickyFooter from "../components/StickyFooter/StickyFooter";
import { getUserData } from "../hooks/HelperFunctions";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import { useSelector } from "react-redux";

const SearchResults = (props) => {
  const router = useRouter();

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );
  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const {
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
    enrollNowHandler,
    showSnackbarMessage,
    filterCheckBoxData,
  } = props;

  const progression = [
    { id: "upcoming", label: "Upcoming", checked: false },
    { id: "inprogress", label: "In-progress", checked: false },
    { id: "completed", label: "Completed", checked: false },
  ];

  const price = [
    { id: "free", label: "Free", checked: false },
    { id: "paid", label: "Paid", checked: false },
  ];

  const [searchChips, setSearchChips] = useState([]);
  const [searchFor, setSearchFor] = useState("courses");

  const [searchBoxText, setSearchBoxText] = useState("");
  const [courses, setCourses] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [totalCourseCount, setTotalCourseCount] = useState(0);
  const [courseLimit, setCourseLimit] = useState(9);
  const [sortBy, setSortBy] = useState("Newest");

  // filter data
  const [topicData, setTopicData] = useState([]);
  const [courseLevels, setCourseLevels] = useState([]);
  const [courseLanguages, setCourseLanguages] = useState([]);
  const [educators, setEducators] = useState([])
  const [progressionData, setProgressionData] = useState(progression);
  const [coursePrice, setCoursePrice] = useState(price);

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const searchText = router.query.q;

  // console.log(props.filterCheckBoxData);

  useEffect(() => {
    const { topic, courseLevels, courseLanguages, educators } = filterCheckBoxData.body;
    
    setTopicData(topic);
    setCourseLevels(courseLevels);
    setCourseLanguages(courseLanguages);
    setEducators(educators);
  }, [filterCheckBoxData]);

  // useEffect(() => {
  //   if (searchText) {
  //     setTimeout(() => {
  //       setSearchBoxText(searchText);
  //     }, 2500);
  //   }
  // }, [searchText]);

  const getCourseList = () => {
    let postData = {};
    postData["searchFor"] = searchFor;
    postData["allCourses"] = true;
    postData["allTracks"] = true;
    postData["searchText"] = searchText;
    // postData["searchText"] = searchBoxText;
    postData["sortBy"] = sortBy;
    postData["limit"] = courseLimit;
    let activeCurrencyFromLocalStorage = localStorage.getItem("activeCurrency")
    postData["currency"] = activeCurrencyFromLocalStorage || "USD";
    let userInfo = getUserData();

    postData["checkBoxData"] = {
      topicData: topicData,
      courseLevels: courseLevels,
      courseLanguages: courseLanguages,
      progressionData: progressionData,
      coursePrice: coursePrice,
      educators: educators,
    };
    postData["userId"] = userInfo?.id;
    setOpenBackdrop(true);

    if (searchFor == "courses") {
      axios
        .post(`${baseUrl}/getCourses`, postData)
        .then((response) => {
          const totalCourseCount = response.data.totalRows;
          setTotalCourseCount(totalCourseCount);

          const filteredCourses = response.data.finalDataArrayGenaral?.filter(
            (singleCourse) => singleCourse?.accountStatus != "pending"
          );
          // Apply client-side sorting to ensure correct order after filtering
          const allCourses = filteredCourses?.sort((a, b) => {
            if (sortBy === "Name A-Z") {
              return (a.courseTitle || "").localeCompare(b.courseTitle || "");
            }
            // Default: Sort by courseId descending (newest first)
            // return b.courseId - a.courseId;
          });
          // console.log(allCourses, 609, postData, "postData");
          setCourses(allCourses);
          setTracks([]);
          setOpenBackdrop(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setOpenBackdrop(false);
        });
    } else if (searchFor == "diploma" || searchFor == "certificate") {
      axios
        .post(`${baseUrl}/getTrackCards`, postData)
        .then((response) => {
          const totalCourseCount = response.data.totalRows;
          setTotalCourseCount(totalCourseCount);

          const tracks = response.data.body;

          setTracks(tracks);
          setCourses([]);
          setOpenBackdrop(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setOpenBackdrop(false);
        });
    }
  };

  useEffect(() => {
    let activeCurrencyFromLocalStorage = localStorage.getItem("activeCurrency")
    if((activeCurrencyFromLocalStorage && activeCurrency == activeCurrencyFromLocalStorage) || !activeCurrencyFromLocalStorage){
      getCourseList();
    }
  }, [searchText, courseLimit, sortBy, searchFor, activeCurrency]);
  // useEffect(() => {
  //   if (searchText != "") {
  //     getCourseList();
  //   }

  // }, [searchBoxText, courseLimit, sortBy, searchFor]);

  const sortByHandler = (selectedOption) => {
    setSortBy(selectedOption);
  };

  const checkboxHandler = (index, selectedOption, type) => {
    getCourseList();
  };

  return (
    <>
      <SimpleBackdrop open={openBackdrop} />
      <Header
        updateCart={updateCart}
        setUpdateCart={setUpdateCart}
        openSignUpModel={openSignUpModel}
        setOpenSignUpModel={setOpenSignUpModel}
      />
      <Container maxWidth="lg" sx={{ minHeight: "100vh !important" }}>
        {searchBoxText ? (
          <h1>
            {totalCourseCount} results for “{searchBoxText}”
          </h1>
        ) : (
          <h1>Explore courses</h1>
        )}
        <SearchResult
          searchBoxText={searchBoxText}
          courses={courses}
          tracks={tracks}
          searchFor={searchFor}
          setSearchFor={setSearchFor}
          totalCourseCount={totalCourseCount}
          setUpdateCart={setUpdateCart}
          enrollNowHandler={enrollNowHandler}
          courseLimit={courseLimit}
          setCourseLimit={setCourseLimit}
          sortByHandler={sortByHandler}
          checkboxHandler={checkboxHandler}
          topicData={topicData}
          setTopicData={setTopicData}
          courseLanguages={courseLanguages}
          setCourseLanguages={setCourseLanguages}
          educators={educators}
          setEducators={setEducators}
          courseLevels={courseLevels}
          setCourseLevels={setCourseLevels}
          progressionData={progressionData}
          setProgressionData={setProgressionData}
          coursePrice={coursePrice}
          setCoursePrice={setCoursePrice}
          searchPage={true}
          setOpenSignUpModel={setOpenSignUpModel}
        />
      </Container>
      <StickyFooter />
      <Footer />
    </>
  );
};

export async function getServerSideProps() {
  const apiBaseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  try {
    const response = await fetch(`${apiBaseUrl}/getFilterCheckBoxData`);
    const filterCheckBoxData = await response.json();
    return {
      props: {
        filterCheckBoxData: filterCheckBoxData,
      },
    };
  } catch (error) {
    console.error("Error fetching data on server side:", error);
    return {
      props: {},
    };
  }
}

export default SearchResults;
